import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable, Filter, FilterTag } from "../../../../../../../components";
import rebateModeEnum from "../../../../../../../enumerations/rebateModeEnum";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../../../plugins/utils";
import { useGetFinancialReportDetail } from "../../../../hooks/financial.hooks";
import { filterKey } from "../../enumerations/filterKeyEnum";
import { filterSetup } from "../../enumerations/filterSetupEnum";

const CURRENCY = getCurrency();

const AgentBonus = ({ date = null, type = null, rebateMode = undefined }) => {
  const { t } = useTranslation();

  const [localData, setLocalData] = useState([]);
  const [filterDefaultValue, setFilterDefaultValue] = useState({
    [filterKey.ACCOUNT]: "",
    [filterKey.AGENT_ACCOUNT]: "",
    [filterKey.LEVEL]: "all",
  });
  const [filterValue, setFilterValue] = useState({
    [filterKey.ACCOUNT]: "",
    [filterKey.AGENT_ACCOUNT]: "",
    [filterKey.LEVEL]: "all",
  });
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading, isError } =
    useGetFinancialReportDetail({
      type: type,
      params:
        rebateMode !== rebateModeEnum.WINLOSE
          ? {
              date: date,
              ...filterValue,
            }
          : {
              date: date,
            },
      options: {
        getNextPageParam: (lastPage, pages) => {
          if (pages.length < lastPage.last_page) {
            return pages.length + 1;
          } else {
            return undefined;
          }
        },
      },
      enabled: date !== null && type !== null,
    });
  const onHandleSearch = () => {};
  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (data) {
      const page_length = data.pages.length;
      if (page_length <= 1) {
        setLocalData([...data.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...data.pages[page_length - 1].data];
        });
      }
    }
  }, [data]);

  const columns = [
    {
      title: t("normal.account"),
      align: "center",
      width: 230,
      dataIndex: "account",
    },
    {
      title: t("normal.uid"),
      align: "center",
      width: 120,
      dataIndex: "account_id",
    },
    {
      title: t("normal.level"),
      width: 100,
      dataIndex: "level",
      align: "center",
      hideInTable: rebateMode === rebateModeEnum.WINLOSE,
    },
    {
      title: t("normal.agent.account"),
      width: 240,
      dataIndex: "agent_account",
      align: "center",
      hideInTable: rebateMode === rebateModeEnum.WINLOSE,
    },
    {
      title: t("mobile.financialReport.totalAmount", {
        currency: t(`global.currency.${CURRENCY}`),
      }),
      align: "center",
      width: 120,
      dataIndex: "total_bonus_amount",
      render: (text, record, index) => {
        return moneyFormat(text);
      },
    },
  ];

  const renderFilter = () => {
    if (rebateMode && rebateMode !== rebateModeEnum.WINLOSE) {
      return (
        <>
          <Filter
            filterSetup={filterSetup}
            filterDefaultValue={filterDefaultValue}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            onReset={() => {
              //if need some aditional reset logic in the page
              console.debug("RESET FILTER");
            }}
            onSubmitSearch={onHandleSearch}
          />
          <FilterTag
            filterSetup={filterSetup}
            filterValue={filterValue}
            filterDefaultValue={filterDefaultValue}
            setFilterValue={setFilterValue}
            refreshSearch={onHandleSearch}
          />
        </>
      );
    }
    return null;
  };

  return (
    <div>
      {renderFilter()}
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
        />
      )}
    </div>
  );
};

export default AgentBonus;
